import React from 'react'
import Icon from '../../misc/Icons'
import { buildHelpSearchUrl } from '../../../services/search/local/externalLinksRegistry'

// Per-variant copy. Kept inline because each row is short and the variant
// list is small — sharing strings via a helper would obscure the call site.
function getVariantCopy(variant, suggestion, query) {
  switch (variant) {
    case 'quickAction':
      return {
        icon: (suggestion && suggestion.icon) || 'plus',
        kindLabel: 'Quick Action',
        title: (suggestion && suggestion.label) || 'Quick Action',
        subtitle: 'Press Enter to run this action.',
      }
    case 'nav':
      return {
        icon: 'compass',
        kindLabel: 'Navigation',
        title: (suggestion && suggestion.label) || 'Navigate',
        subtitle: suggestion && suggestion.path ?
          `Press Enter to go to ${suggestion.path}.` :
          'Press Enter to navigate.',
      }
    case 'external':
      return {
        icon: 'web',
        kindLabel: 'External link',
        title: (suggestion && suggestion.label) || 'External link',
        subtitle: (suggestion && suggestion.url) || '',
        hint: 'Opens in a new tab.',
      }
    case 'helpShowMore':
      return {
        icon: 'book-open',
        kindLabel: 'Help center',
        title: `See all help results${query ? ` for "${query}"` : ''}`,
        subtitle: buildHelpSearchUrl(query),
        hint: 'Opens help.plickers.com in a new tab.',
      }
    case 'showMore':
      return {
        icon: 'search',
        kindLabel: 'All results',
        title: `Open full results${suggestion && suggestion.showMore ? ` for "${suggestion.showMore}"` : ''}`,
        subtitle: 'Press Enter to go to the search results page.',
      }
    case 'recentMissing':
      return {
        icon: 'history',
        kindLabel: 'Recent',
        title: 'Recent item',
        subtitle: 'This item is no longer available locally.',
      }
    case 'empty':
    default:
      return {
        icon: 'search',
        kindLabel: 'Search',
        title: 'Search Plickers',
        subtitle: 'Type to find packs, folders, sets, and questions — or pick a suggestion to preview it here.',
        hint: 'Tip: press Cmd+K (or Ctrl+K) to focus the search bar from anywhere.',
      }
  }
}

function SearchPreviewInfo({ variant, suggestion, query }) {
  const copy = getVariantCopy(variant, suggestion, query)
  return (
    <div className={`searchPreviewPane-body searchPreviewInfo searchPreviewInfo--${variant}`}>
      <div className='searchPreviewInfo-icon'>
        <Icon name={copy.icon} />
      </div>
      <div className='searchPreviewInfo-kind'>{copy.kindLabel}</div>
      <div className='searchPreviewInfo-title'>{copy.title}</div>
      {copy.subtitle && (
        <div className='searchPreviewInfo-subtitle'>{copy.subtitle}</div>
      )}
      {copy.hint && (
        <div className='searchPreviewInfo-hint'>{copy.hint}</div>
      )}
    </div>
  )
}

export default SearchPreviewInfo
